import { render, staticRenderFns } from "./LeadContacts.vue?vue&type=template&id=6ed676a2&scoped=true&"
import script from "./LeadContacts.vue?vue&type=script&lang=js&"
export * from "./LeadContacts.vue?vue&type=script&lang=js&"
import style0 from "./LeadContacts.vue?vue&type=style&index=0&id=6ed676a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed676a2",
  null
  
)

export default component.exports